import { app_generic_resources_ext_RowInterface, app_generic_resources_hdr_RowClass, app_generic_resources_hdr_RowInterface, app_generic_resource_line_RowClass, app_generic_resource_line_RowInterface } from '../../dbschema';
import {BaseContainerModel} from '../base-container.model';

export class GenericResourcesContainerModel extends BaseContainerModel {
  app_generic_resources_hdr: app_generic_resources_hdr_RowInterface = new app_generic_resources_hdr_RowClass();
  app_generic_resource_lines: app_generic_resource_line_RowInterface[] = [];
  app_generic_resources_exts: app_generic_resources_ext_RowInterface[] = [];
}

